import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';

//  Redux States
import { ContactsActionTypes } from './types';
import {
    contactsApiResponseSuccess,
    contactsApiResponseError
} from './actions';

// api
import {
    getContacts as getContactsApi,
    createContact as createContactApi,
    editContact as editContactApi,
    deleteContact as deleteContactApi
} from '../../api/index';

// helpers
import {
    showSuccessNotification,
    showErrorNotification
} from '../../helpers/notifications';
import { chatsApiResponseSuccess } from '../actions';
import { ChatsActionTypes } from '../chats/types';
import { getPreference } from '../../utils';

const selectLoginState = (state: any) => state.Login;

function* getContacts({ payload: filters }: any): Generator<any, void, any> {
    try {
        const {
            user: { preferences }
        } = yield select(selectLoginState);
        const chunkSize = getPreference(
            preferences,
            'GENERAL_PREFERENCES',
            'PERSON_PAG'
        );

        const response: Promise<any> = yield call(
            getContactsApi,
            filters.search,
            filters.page,
            chunkSize ? +chunkSize : 10
        );
        yield put(
            contactsApiResponseSuccess(
                ContactsActionTypes.GET_CONTACTS,
                response
            )
        );
    } catch (error: any) {
        yield put(
            contactsApiResponseError(ContactsActionTypes.GET_CONTACTS, error)
        );
    }
}

function* createContact({ payload: data }: any) {
    try {
        const response: Promise<any> = yield call(createContactApi, data);
        yield put(
            contactsApiResponseSuccess(
                ContactsActionTypes.CREATE_CONTACT,
                response
            )
        );
        yield call(showSuccessNotification, response);
    } catch (error: any) {
        yield call(showErrorNotification, error);
        yield put(
            contactsApiResponseError(ContactsActionTypes.CREATE_CONTACT, error)
        );
    }
}

function* editContact({ payload: data }: any) {
    try {
        const response: Promise<any> = yield call(
            editContactApi,
            data.data,
            data.personId
        );
        yield put(
            contactsApiResponseSuccess(ContactsActionTypes.EDIT_CONTACT, data)
        );
        yield put(
            chatsApiResponseSuccess(
                ChatsActionTypes.UPDATE_CHAT_USER_DETAILS,
                data
            )
        );
        yield call(showSuccessNotification, response);
    } catch (error: any) {
        yield call(showErrorNotification, error);
        yield put(
            contactsApiResponseError(ContactsActionTypes.EDIT_CONTACT, error)
        );
    }
}

function* deleteContact({ payload: personId }: any) {
    try {
        const response: Promise<any> = yield call(deleteContactApi, personId);
        yield put(
            contactsApiResponseSuccess(
                ContactsActionTypes.DELETE_CONTACT,
                personId
            )
        );
        yield put(
            chatsApiResponseSuccess(
                ChatsActionTypes.RESET_CHAT_USER_DETAILS,
                {}
            )
        );
        yield call(showSuccessNotification, response);
    } catch (error: any) {
        yield call(showErrorNotification, error);
        yield put(
            contactsApiResponseError(ContactsActionTypes.DELETE_CONTACT, error)
        );
    }
}

export function* watchGetContacts() {
    yield takeEvery(ContactsActionTypes.GET_CONTACTS, getContacts);
}

export function* watchCreateContact() {
    yield takeEvery(ContactsActionTypes.CREATE_CONTACT, createContact);
}

export function* watchEditContact() {
    yield takeEvery(ContactsActionTypes.EDIT_CONTACT, editContact);
}

export function* watchDeleteContact() {
    yield takeEvery(ContactsActionTypes.DELETE_CONTACT, deleteContact);
}

function* contactsSaga() {
    yield all([
        fork(watchGetContacts),
        fork(watchCreateContact),
        fork(watchEditContact),
        fork(watchDeleteContact)
    ]);
}

export default contactsSaga;
